import { useTranslation } from 'react-i18next';

import {
  ConfirmationDialogActionProceedButton,
  ConfirmationDialogActions,
  ConfirmationDialogBodyMutedText,
  ConfirmationDialogContainer,
  ConfirmationDialogHeader,
  type ConfirmationDialogContainerProps,
} from '@/components/dialogs/elements.confirmation-dialog';

type InfoWarningDialogProps = ConfirmationDialogContainerProps & {
  headerText?: string;
  bodyMessage?: React.ReactNode;
};

export const InfoDialog = (props: InfoWarningDialogProps) => {
  const { headerText, bodyMessage, onClose, ...restOfDialogProps } = props;
  const { t } = useTranslation('dialogs');

  return (
    <ConfirmationDialogContainer onClose={onClose} {...restOfDialogProps}>
      <ConfirmationDialogHeader>{headerText}</ConfirmationDialogHeader>
      <ConfirmationDialogBodyMutedText>{bodyMessage}</ConfirmationDialogBodyMutedText>

      <ConfirmationDialogActions>
        <ConfirmationDialogActionProceedButton onClick={onClose}>
          {t('info-warning-dialog.actions.close')}
        </ConfirmationDialogActionProceedButton>
      </ConfirmationDialogActions>
    </ConfirmationDialogContainer>
  );
};
